import { render, staticRenderFns } from "./PayJsf.vue?vue&type=template&id=b6d06fd6&scoped=true"
import script from "./PayJsf.vue?vue&type=script&lang=js"
export * from "./PayJsf.vue?vue&type=script&lang=js"
import style0 from "./PayJsf.vue?vue&type=style&index=0&id=b6d06fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d06fd6",
  null
  
)

export default component.exports